import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  Legend, ResponsiveContainer
} from 'recharts';
import { colors } from '../../brand-colors';

/**
 * Affiliate Results Chart - Horizontal bar by affiliate name
 * Shows Leads, Tripwire, and Core Product sales per affiliate
 */
function AffiliateResultsChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div style={styles.placeholder}>
        <p>No affiliate data available</p>
        <small>Connect GHL to see affiliate performance</small>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 20, right: 30, left: 80, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          type="number"
          tick={{ fill: colors.grey, fontSize: 12 }}
        />
        <YAxis
          type="category"
          dataKey="name"
          tick={{ fill: colors.grey, fontSize: 11 }}
          width={70}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            color: colors.greyDarkest
          }}
        />
        <Legend />
        <Bar
          dataKey="leads"
          name="Leads"
          stackId="a"
          fill={colors.tealMid}
        />
        <Bar
          dataKey="tripwire"
          name="Tripwire"
          stackId="a"
          fill={colors.teal}
        />
        <Bar
          dataKey="core_product"
          name="Core Product"
          stackId="a"
          fill={colors.tealDark}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

const styles = {
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 250,
    color: colors.greyMid,
    textAlign: 'center'
  }
};

export default AffiliateResultsChart;
